"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvAdd = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const EnvAdd = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "10",
      strokeWidth: "1.1095",
      d: "M5.949 2.847c0.599 0.575 1.077 1.271 1.395 2.049l0.014 0.040c0.389 0.277 0.697 0.644 0.897 1.072l0.007 0.017c0.059 0.223 0.093 0.479 0.093 0.742 0 0.247-0.030 0.487-0.086 0.716l0.004-0.021s0.61 1.791 0.323 2.294-1.508 0.825-1.508 0.825c-0.334 0.563-0.881 0.969-1.528 1.11l-0.016 0.003c-0.763 0.044-1.366 0.673-1.366 1.444 0 0.022 0 0.044 0.001 0.066l-0-0.003c0 0.969 0.969 2.548 0.969 2.548s1.005 0.491 1.149 0.85c0.102 0.352 0.17 0.761 0.191 1.182l0.001 0.013s0.959 1.687 0.418 2.658c-0.171 0.31-0.969 0.539-0.969 0.539l-1.118 1.676"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      strokeLinejoin: "miter",
      strokeLinecap: "butt",
      strokeMiterlimit: "10",
      strokeWidth: "1.1095",
      d: "M23.161 5.441c-0.938 0.406-2.057 0.775-3.213 1.045l-0.139 0.027s-1.558 1.735-2.581 1.591-2.064-1.292-2.064-1.292 0.072-2.118-0.251-2.225-1.184 0.467-1.722 0.035-0.228-1.645-0.228-1.645-1.174-0.365-1.315-0.758 0.427-1.276 0.535-1.612"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      strokeLinejoin: "miter",
      strokeLinecap: "square",
      strokeMiterlimit: "10",
      strokeWidth: "1.1095",
      d: "M19.206 11.898l0.039-0.083c-0.638-0.222-1.379-0.38-2.146-0.442l-0.032-0.002c-0.357-0.229-0.767-0.434-1.199-0.595l-0.045-0.015c-0.431-0.108-1.843 0.359-1.843 0.359s-1.72 2.081-1.72 2.871c0 0.323 0.621 0.823 1.076 1.273"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      strokeLinejoin: "miter",
      strokeLinecap: "square",
      strokeMiterlimit: "10",
      strokeWidth: "1.1095",
      d: "M24.991 8.686c-1.869-4.789-6.445-8.12-11.8-8.12-6.978 0-12.634 5.656-12.634 12.634 0 5.736 3.823 10.579 9.060 12.121l0.089 0.023"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M35.531 21.738c0 5.668-4.595 10.262-10.262 10.262s-10.262-4.595-10.262-10.262c0-5.668 4.595-10.262 10.262-10.262s10.262 4.595 10.262 10.262z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M25.268 18.687c0.153 0 0.277 0.124 0.277 0.277v6.102c0 0.153-0.124 0.277-0.277 0.277s-0.277-0.124-0.277-0.277v-6.102c0-0.153 0.124-0.277 0.277-0.277z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M21.94 22.015c0-0.153 0.124-0.277 0.277-0.277h6.102c0.153 0 0.277 0.124 0.277 0.277s-0.124 0.277-0.277 0.277h-6.102c-0.153 0-0.277-0.124-0.277-0.277z"
    })]
  });
};
exports.EnvAdd = EnvAdd;